import {Injectable, Inject, PLATFORM_ID, NgZone} from '@angular/core';
import {BehaviorSubject, Subject, Observable} from 'rxjs';
import {isPlatformBrowser} from '@angular/common';
import * as moment from 'moment-timezone';

declare var require: any

@Injectable()

export class GlobalService {
  enableSwipe = true;
  loadingIndicator: boolean;
  pinnedLoc = new BehaviorSubject<any>({
    name: '',
    longitude: 0,
    latitude: 0
  });
  language = 'en';
  timezone = require('moment-timezone');
  socket: any;
  slug = '';
  isBrwoser = true;
  domain: string;
  countries = new BehaviorSubject<any>('');
  customLang;
  langChosen = 'en';
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrwoser = isPlatformBrowser(platformId);
  }


  timeConverter(UNIX_timestamp) {
    let a = new Date(UNIX_timestamp);
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let year = a.getFullYear();
    let month = (a.getMonth() + 1);
    let date = a.getDate();
    let hour = a.getHours();
    let am_pm = (hour < 12 || hour === 24) ? 'AM' : 'PM';
    hour = hour % 12 || 12;
    let min = a.getMinutes();
    let sec = a.getSeconds();
    let time = (date < 10 ? ('0' + date) : date) + '-' + (month < 10 ? ('0' + month) : month) + '-' + year + ' ' + (hour < 10 ? ('0' + hour) : hour) + ':' + (min < 10 ? ('0' + min) : min) + ':' + (sec < 10 ? ('0' + sec) : sec) + '  ' + am_pm;
    return time;
  }

  Date(date) {
    return this.timezone(date, 'x').format('ddd, MMM DD');

  }

  Time(date) {
    return this.timezone(date, 'x').format('LT z');
  }

  dateFullFormat(date) {
    return this.timezone(date, 'x').format('llll');
  }

  // Thu, Jul 19, 2018
  utcTimeStamp(value, timezone?) {
    // , this.timezone.tz.guess()
    let unixTimeStamp;
    if (timezone) {
      unixTimeStamp = this.timezone.tz(value, timezone).format();
    } else {
      unixTimeStamp = value;
    }
    return unixTimeStamp;
  }

  getCountryAbbr(country) {
    let abbr;
    if (this.countries.value) {
      this.countries.value.forEach((item, index) => {
        if (item.name === country) {
          abbr = item.abbr;
        }
      });
    }
    return abbr.toLowerCase();
  }

}
